import * as React from "react";

import {
  Collapse,
  Container,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Image from "next/image";
import successCheck from "../../../../../public/assets/images/op/success_check.png";
import CustomWidthTooltip from "./CustomTooltip";
import AgapeIcon from "../../../../common/icons/AgapeIcon";
import Grades from "../../../../common/rate/Grades";
import ConfirmationBox from "../../old_OP/components/ConfirmationBox";
import RoundButton from "../../../../common/button/RoundButton";
import PaymentOptions from "./PaymentOptions";
import OptionsMenu from "./OptionsMenu";
import BeforeSendDialog from "../../old_OP/components/BeforeSendDialog";
import {
  favoriteOrganization,
  requestOwner,
} from "../../../../../services/AgapeAPI";

import ShareModal from "../../old_OP/components/ShareModal";
import ReportDialog from "../../../../common/reportDialog/ReportDialog";
import OrganizationPaymentDialog from "./OrganizationPaymentDialog";
import { Stack } from "@mui/material";
import Link from "next/link";


const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    backgroundColor: "#fff",
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
    boxShadow: "-1px 2px 5px 0 #0003",
    paddingTop: 70,
    paddingBottom: 10,
  },
  stickyContainer: (props) => ({
    position: props.noSticky ? "relative" : "sticky",
    top: props.noSticky ? "initial" : "-210px",
    zIndex: props.noSticky ? "auto" : 1000,
  }),
  logo: {
    borderRadius: "100%",
  },
  divLogo: {
    position: "absolute",
    backgroundColor: "#fff",
    padding: 2,
    top: "-50px",
    width: 104,
    height: 104,
    borderRadius: "100%",
    boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.10)",
  },
  t1: {
    fontSize: "18px",
    fontWeight: "bold",
    paddingBottom: 10,
    display: "inline-block",
  },
  scoret: {
    fontWeight: "bold",
    fontSize: "18px",
  },
  t2: {
    fontSize: "18px",
    paddingBottom: 10,
    display: "inline-block",
  },
  successCheckBody: {
    position: "relative !important",
    bottom: "-10px",
    padding: "0 10px",
  },
  successCheck: {
    display: "block !important",
    position: "absolute !important",
    marginBottom: "-10px",
  },
  tooltip: {
    backgroundColor: "#fff !important",
    color: "#000",
    fontSize: "16px",
  },
  grade: {
    width: 40,
    display: "inline-block",
    position: "absolute",
    right: "0px",
    top: "-7px",
  },
  btnGroup: {
    display: "flex",
    cursor: "pointer",
    flexBasis: "auto",
    position: "relative",
  },
  btnPar: {
    width: 50,
    backgroundColor: "#009693",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottomRightRadius: "5px",
    borderTopRightRadius: "5px",
    borderLeft: "solid 1px #fff",
  },
  btn: {
    borderRadius: "0px",
    borderBottomLeftRadius: "5px",
    borderTopLeftRadius: "5px",
  },
  fg: {
    flexGrow: "1",
  },
  tr: {
    transform: "rotate(90deg)",
  },
  dotsPar: {
    display: "flex",

    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px",
    boxShadow: "0 2px 10px 0 #0002",
    width: 40,
    height: 40,
    cursor: "pointer",
    position: "relative",
  },
  dots: {
    fontSize: 25,
    paddingTop: 0,
    fontWeight: "bold",
    color: "#009693",
    marginTop: "-10px",
  },
  btnMember: {
    boxShadow: "1px 2px 10px #29292944",
  },
}));

const OrganizationHeader = ({ data,withouthButtons = false, noSticky = false, ...props }) => {
  const classes = useStyles({noSticky});

  const [membershipModal, setMembershipModal] = React.useState(false);
  const [openPayment, setOpenPayment] = React.useState(false);
  const [openOptins, setOpenOptions] = React.useState(false);
  const [openPaymentDialog, setOpenPaymentDialog] = React.useState(false);
  const [openRequestOwner, setOpenRequestOwner] = React.useState(false);
  const [currentCount, setCurrentCount] = React.useState(data.favorites_count);
  const [openModal, setOpenModal] = React.useState(false);
  const [openReport, setOpenReport] = React.useState(false);

  const [requestOwnerReadyToSend, setRequestOwnerReadyToSend] =
    React.useState(false);
  const [localFavorite, setLocalFavorite] = React.useState(
    data.is_favorited ? 1 : 0
  );

  const localFavorites = JSON.parse(
    typeof window !== "undefined" && localStorage.getItem("favorites")
  );

  const handleShareClicked = () => {
    setOpenModal(!openModal);
  };

  React.useEffect(() => {
    if (!localFavorites) {
      localStorage.setItem("favorites", JSON.stringify([]));
    } else if (localFavorites.indexOf(data?.code) > -1) {
      setLocalFavorite(1);
    }
  }, [localFavorites, localFavorite, data?.code]);

  const handleFavorite = () => {
    if (localFavorite === 1) {
      dislikeOrganization(data.code).then((response) => {
        setLocalFavorite(0);
        setCurrentCount(currentCount - 1);
      });
    } else {
      favoriteOrganization(data.code).then((response) => {
        setLocalFavorite(1);
        setCurrentCount(currentCount + 1);
      });
    }
  };

  const openMembership = () => {
    setMembershipModal(!membershipModal);
  };

  const handleOpenPaymentDialog = () => {
    setOpenPaymentDialog(!openPaymentDialog);
  };

  React.useEffect(() => {
    async function handleOwnershipRequest() {
      if (requestOwnerReadyToSend) {
        requestOwner(data?.code).then((response) => {
          setHasRequestedOwner(true);
          localStorage.setItem(`reqOwner__${data?.code}`, true);
          setOpenOwner(true);
        });
      }
    }
    handleOwnershipRequest();
  }, [requestOwnerReadyToSend]);

  return (
    <Grid container className={classes.stickyContainer}>
      <OrganizationPaymentDialog
        data={data}
        open={openPaymentDialog}
        setOpen={setOpenPaymentDialog}
      />

      <ReportDialog
        open={openReport}
        setOpen={setOpenReport}
        id={data.code}
        url="organizations"
      />
      <ShareModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        closeHandler={() => setOpenModal(false)}
        link={data?.share_link}
        slug={data.slug}
      />
      {!!data.membership_config && (
        <ConfirmationBox
          openModal={membershipModal}
          setOpenModal={openMembership}
          closeHandler={() => setMembershipModal(false)}
          config={data.membership_config}
          id={data?.code}
          slug={data?.slug}
        />
      )}
      <BeforeSendDialog
        open={openRequestOwner}
        setOpen={setOpenRequestOwner}
        setReadyToSend={setRequestOwnerReadyToSend}
        title="آیا از ارسال درخواست اطمینان دارید؟"
        subtitle="تنها مدیر حقوقی سازمان می‌تواند با ثبت درخواست مدیریت از قابلیت‌های داشبورد اختصاصی بهره‌مند شود."
      />
      <Grid item md={12}>
        <div>
          {data.banner && (
            <Image
              title={data.brand_name || data.name}
              alt={data.brand_name || data.name}
              src={data.banner}
              placeholder="blur"
              blurDataURL={data.banner}
              layout="responsive"
              width={1280}
              height={300}
            />
          )}
          <Container className={classes.container}>
            {data.logo && (
              <div className={classes.divLogo}>
                <Image
                  title={data.brand_name || data.name}
                  alt={data.brand_name || data.name}
                  src={data.logo}
                  placeholder="blur"
                  blurDataURL={data.logo}
                  width={100}
                  height={100}
                  className={classes.logo}
                />
              </div>
            )}
            <Grid container>
              <Grid item md={6} container>
                <Grid item xs={12}>
                  <Typography variant="h1" className={classes.t1}>
                    {data.brand_name || data.name}{" "}
                  </Typography>
                  {data.grade === "A" ||
                  data.grade === "B" ||
                  data.grade === "C" ? (
                    <CustomWidthTooltip
                      placement="top-start"
                      arrow
                      leaveDelay={100}
                      followCursor
                      title={
                        <Typography variant="h5" className={classes.tooltip}>
                          تیک آبی نشان دهنده آن است که موسسه مورد نظر اعتبارسنجی
                          و اصالت سنجی شده و امتیاز این سطح را اخذ نموده است.
                        </Typography>
                      }
                    >
                      <span className={classes.successCheckBody}>
                        <Image
                          width={27}
                          height={27}
                          src={successCheck}
                          alt={data.brand_name || data.name}
                          // title={data.brand_name || data.name}
                          placeholder="blur"
                          className={classes.successCheck}
                        />
                      </span>
                    </CustomWidthTooltip>
                  ) : null}
                </Grid>
                {data.brand_name ? (
                  <Grid item xs={12}>
                    <Typography variant="h2" className={classes.t2}>
                      {data.name}
                    </Typography>
                  </Grid>
                ) : (
                  ""
                )}
                {data.subject && (
                  <Grid item xs={12}>
                    <Typography variant="h2" className={classes.t2}>
                      {data.subject}
                    </Typography>
                  </Grid>
                )}
              </Grid>
              {
                !withouthButtons && (<Grid item md={6}>
                  <Grid item xs={12} container spacing={2} justify="flex-end">
                    <Stack
                      direction={"row"}
                      position={"relative"}
                      width={"13%"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      marginBottom={"20px"}
                    >
                      {data.grade === "A" && (
                        <span className={classes.grade}>
                          <Grades grade={data.grade} />{" "}
                        </span>
                      )}
                      <Stack
                        direction={"row"}
                        width={data.grade === "A" ? "70%" : "100%"}
                        justifyContent={data.grade === "A" ? "" : "left"}
                        alignItems={"center"}
                      >
                        <AgapeIcon
                          icon="star-full"
                          color={data.users_score ? "#F5B502" : "#999"}
                          size="20px"
                        />{" "}
                        <Typography className={classes.scoret}>
                          {data.users_score}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} container spacing={2}>
                    <Grid item xs={5}>
                      {(data.organization_category_id === 1 ||
                      data.organization_category_id === 2 ||
                        data.organization_category_id === 4 )&&
                        data.is_accepted_member === 1 ? (
                        <Link href={`/membership/حقیقی/${data?.slug}/${data?.code}`}>
                          <RoundButton
                            disabled={data.is_accepted_member !== 1}
                            // disable the membership request modal 
                            // when the legal memberships is added
                            //activate this modal again
                            // onClick={openMembership}
                            fullWidth
                            radius="5px"
                            fontSize="1.318rem"
                            bgColor="#fff"
                            borderColor="#fff"
                            textColor="#009693"
                            iconColor="#009693"
                            icon="house"
                            customClassName={classes.btnMember}
                          >
                            درخواست عضویت
                          </RoundButton>
                        </Link>

                      ) : null}
                    </Grid>
                    <Grid item xs={6}>
                      <div
                        className={classes.btnGroup}
                        onClick={() => setOpenPayment(true)}
                      >
                        <div className={classes.fg}>
                          <RoundButton
                            fullWidth
                            fontSize="1.318rem"
                            icon="org-heart"
                            customClassName={classes.btn}
                          >
                            حمایت از موسسه
                          </RoundButton>
                        </div>
                        <div className={classes.btnPar}>
                          <AgapeIcon
                            icon="chevron"
                            size="20px"
                            color="#fff"
                            className={classes.tr}
                          />
                        </div>
                        <Collapse in={openPayment} timeout={1000}></Collapse>
                        {openPayment && (
                          <PaymentOptions
                            setOpen={setOpenPayment}
                            open={openPayment}
                            data={data}
                            handleOpenPaymentDialog={handleOpenPaymentDialog}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={1}>
                      <div
                        className={classes.dotsPar}
                        onClick={() => setOpenOptions(true)}
                      >
                        <Typography variant="p" className={classes.dots}>
                          ...
                        </Typography>
                        {openOptins && (
                          <OptionsMenu
                            setOpen={setOpenOptions}
                            open={openOptins}
                            data={data}
                            openMembership={openMembership}
                            localFavorite={localFavorite}
                            handleFavorite={handleFavorite}
                            currentCount={currentCount}
                            handleShareClicked={handleShareClicked}
                            setOpenReport={setOpenReport}
                          />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>)
              }
            </Grid>
          </Container>
        </div>
      </Grid>
    </Grid>
  );
};

export default OrganizationHeader;
